import { SSEClientManager } from "@/shared/services/SSEClientManager";
import { baseURL, endpoints } from ".";

const stocksRatingsSSEClient = new SSEClientManager({
  endpoint: baseURL + endpoints.stocksRatingsStream,
  connectionName: "StocksRatings-SSE",
  activityTimeoutMs: 45000,
});

export default stocksRatingsSSEClient;
